App.controller('HealthInsuranceWithPaymentsDocumentCtrl', ['$scope', '$sce', '$state', '$http', 'packageService', '$stateParams', function ($scope, $sce, $state, $http, packageService, $stateParams) {
    $scope.stateParams = $stateParams;

    $scope.page = 'healthInsuranceWithPayments_document';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Dokumenty do pobrania';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.healthInsuranceWithPayments.start';
    $scope.$emit('link', $scope.link);
}]);
